<template>
  <div class="maintenance-page">
    <div class="maintenance-card">
      <div class="maintenance-icon" aria-hidden="true">
        <svg
          class="maintenance-icon-svg"
          viewBox="0 0 64 64"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22 26.5C22 20.7 26.7 16 32.5 16C38.3 16 43 20.7 43 26.5V35.6C43 37.6 43.8 39.5 45.1 40.9L47 43H18L19.9 40.9C21.2 39.5 22 37.6 22 35.6V26.5Z"
          />
          <path d="M30 48C30.5 49.8 31.9 51 33.5 51C35.1 51 36.5 49.8 37 48" />
          <path d="M32.5 12V14.5" />
        </svg>
      </div>

      <h1 class="maintenance-title">Notificacion del sistema</h1>

      <div class="maintenance-content">
        <p>
          El mantenimiento del sistema ha finalizado y la funcion de devolucion
          ya vuelve a estar disponible.
        </p>
        <p>
          Gracias por su paciencia. Actualmente, ya puede realizar el pago de
          sus cuotas con normalidad.
        </p>
        <p>
          Cualquier retraso en los pedidos y cualquier cargo adicional generado
          durante el periodo de la incidencia seran exonerados en su totalidad.
        </p>
        <p>
          Si tiene cualquier consulta, puede contactar con nuestro servicio de
          atencion al cliente en el 918 055 475.
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue';

export default defineComponent({
  name: 'maintenancePage',
  setup() {
    onMounted(() => {
      document.title = 'Notificacion del sistema';
    });

    return {};
  }
});
</script>

<style lang="scss" scoped>
.maintenance-page {
  width: 100vw;
  min-height: 100vh;
  margin-left: calc(50% - 50vw);
  padding: 36px 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(circle at top center, rgba(145, 208, 255, 0.14), transparent 34%),
    linear-gradient(180deg, #f6f8fc 0%, #eef3fb 100%);
}

.maintenance-card {
  width: 100%;
  max-width: 760px;
  padding: 42px 34px 48px;
  border-radius: 36px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0 22px 70px rgba(91, 108, 132, 0.12);
}

.maintenance-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 68px;
  height: 68px;
  margin: 0 auto 24px;
}

.maintenance-icon-svg {
  width: 100%;
  height: 100%;

  path {
    fill: none;
    stroke: #f06a00;
    stroke-width: 3;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
}

.maintenance-title {
  margin-bottom: 28px;
  color: #0f1115;
  font-family: Fredoka-Medium, serif;
  font-size: 40px;
  line-height: 1.18;
  text-align: center;
}

.maintenance-content {
  max-width: 536px;
  margin: 0 auto;
  color: #3e434d;
  font-family: Manrope-Medium, serif;
  font-size: 28px;
  line-height: 1.58;
  text-align: left;

  p + p {
    margin-top: 2px;
  }
}

@media (min-width: 1100px) {
  .maintenance-page {
    padding: 56px 28px;
  }

  .maintenance-card {
    max-width: 860px;
    padding: 56px 68px 60px;
    border-radius: 40px;
  }

  .maintenance-icon {
    width: 76px;
    height: 76px;
    margin-bottom: 28px;
  }

  .maintenance-title {
    margin-bottom: 34px;
    font-size: 50px;
  }

  .maintenance-content {
    max-width: 660px;
    font-size: 21px;
    line-height: 1.72;
  }
}

@media (max-width: 767px) {
  .maintenance-card {
    padding: 38px 32px 44px;
  }

  .maintenance-title {
    margin-bottom: 24px;
    font-size: 38px;
  }

  .maintenance-content {
    max-width: 100%;
    font-size: 24px;
    line-height: 1.56;
  }

  .maintenance-content p + p {
    margin-top: 2px;
  }
}
</style>
